module.exports = __webpack_public_path__ + "static/media/redeem.f0aeba5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/redeem.mp3
// module id = HX8k
// module chunks = 5